import localForage from 'localforage';

export const KEYS = {
  CIRCLE_MENU_HIGHLIGHTED: 'circleMenuHighlited',
};

const storageService = {
  get(key: string) {
    return localForage.getItem<any>(key);
  },
  set(key: string, value: any) {
    return localForage.setItem(key, value);
  },
};

export { storageService };
